import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import activityAreaConfig from './config/activityreaConfig';
import { FormRow, Select } from '../common/Forms';

var ActivityAreaContainer = createReactClass({

  getInitialState() {
    return {
      activityAreas: [],
      selectedActivityArea: {
        activityLocations: []
      },
      selectedActivityLocation: {
        activities: []
      },
      selectedActivity: {}
    };
  },

  componentDidMount() {
    request.get({
      url: activityAreaConfig.apiUrl,
      success: activityAreas => {
        if (this.isMounted()) {
          this.setState({
            activityAreas: activityAreas
          });
        }
      }
    });
  },

  handleActivityAreaSelect(activityAreaId) {

    if (!activityAreaId) {
      this.setState({
        selectedActivityArea: {
          activityLocations: []
        },
        selectedActivityLocation: {
          activities: []
        }
      });
    } else {
      var selectedActivityArea = this.state.activityAreas.find(x => x.id === activityAreaId);

      this.setState({
        selectedActivityArea: selectedActivityArea,
        selectedActivityLocation: {
          activities: []
        }
      });
    }
  },

  handleActivityLocationSelect(activityLocationId) {
    if (!activityLocationId) {
      this.setState({
        selectedActivityLocation: {
          activities: []
        }
      });
    } else {
      var selectedActivityLocationIndex = this.state.selectedActivityArea.activityLocations
        .map(x => x.id).indexOf(activityLocationId);

      var selectedActivityLocation = this.state.selectedActivityArea.activityLocations[selectedActivityLocationIndex];

      this.setState({
        selectedActivityLocation: selectedActivityLocation
      });
    }
  },

  render() {
    let activityAreaOptions = this.state.activityAreas.map(area => ({ value: area.id, label: area.name }));
    activityAreaOptions.unshift({value: '', label: 'Bitte wählen…'});

    let activityLocationOptions = this.state.selectedActivityArea.activityLocations.map(location => ({ value: location.id, label: location.name }));
    activityLocationOptions.unshift({value: '', label: 'Bitte wählen…'});

    let activityOptions = this.state.selectedActivityLocation.activities.map(a => ({ value: a.id, label: a.name }));
    activityOptions.unshift({value: '', label: 'Bitte wählen…'});

    return (
      <fieldset>
        <FormRow width={4}>
          <Select
            layout="vertical"
            name="activityAreaId"
            id="activityAreaId"
            label="Art des Einsatzortes:"
            options={activityAreaOptions}
            value={this.state.selectedActivityArea.id}
            onChange={(name, activityAreaId) => this.handleActivityAreaSelect(activityAreaId)}
            required
          />
        </FormRow>

        <FormRow width={4}>
          <Select
            layout="vertical"
            name="activityLocationId"
            id="activityLocationId"
            label="Einsatzort:"
            options={activityLocationOptions}
            value={this.state.selectedActivityLocation.id}
            onChange={(name, activityLocationId) => this.handleActivityLocationSelect(activityLocationId)}
            disabled={!this.state.selectedActivityArea.id}
            required
          />
        </FormRow>

        <FormRow width={4}>
          <Select
            layout="vertical"
            name="activityId"
            id="activityId"
            label="Aktivität:"
            options={activityOptions}
            value={this.state.selectedActivity.id}
            disabled={!this.state.selectedActivityLocation.id}
            required
          />
        </FormRow>
{/*          <div className="row">
              <section className="col col-4">
                  <label className="select">
                      <select onChange={this.onActivityAreaSelected} value={this.state.selectedActivityArea.id}>
                          <option value="0" key={"activityAreaInitialValue"}>Select...</option>
                          {renderedAvailableAvailabilityOptions}
                      </select>
                      <i></i>
                  </label>
              </section>
          </div>
          <div className="row">
              <section className="col col-4">
                  <label className="select">
                      <select onChange={this.onActivityLocationSelect} value={this.state.selectedActivityLocation.id}>
                          <option value="0" key={"activityLocationInitialValue"}>Select...</option>
                          {renderedActivityLocations}
                      </select>
                      <i></i>
                  </label>
              </section>
          </div>
          <div className="row">
              <section className="col col-4">
                  <label className="select">
                      <select onChange={this.onActivitySelected} value={this.state.selectedActivity.id}>
                          <option value="0" key={"activityInitialValue"}>Select...</option>
                          {renderedActivities}
                      </select>
                      <i></i>
                  </label>
              </section>
          </div>*/}
      </fieldset>
    );
  }

});

export default ActivityAreaContainer;



// WEBPACK FOOTER //
// ./src/components/activityarea/ActivityAreaContainer.js